export default { sm: 400, md: 700, xd: 1200 };
